import { TableBody, TableContainer, TableHead, TableRow, TextField, Typography,Grid,Table,TableCell,Chip } from "@mui/material";
import dayjs from "dayjs";
import { FC } from "react"
import { useTranslation } from "react-i18next";
import { ContractPaymentList } from "../page/contract/ContractInterfaces";
import { useStatusValuesContract } from "./useStatusValuesContract";

const PaymentsHistoryTable:FC<{data:ContractPaymentList[],showTyphography?:boolean}> = ({data,showTyphography}) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'contract'});
    const {getStatusColorContract,getStatusLabelContract} = useStatusValuesContract()
    
    return <>
        {showTyphography &&  <Grid item>
                <Typography>{t('paymentsHistoryTable.title')}</Typography>
            </Grid>
        }
      <TableContainer sx={{paddingTop: "10px"}}>
            <Table aria-label="paymentsHistory-table">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography color={"primary"} fontWeight={700} fontSize={'14px'}>
                            {t('paymentsHistoryTable.typology')}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography color={"primary"} fontWeight={700} fontSize={'14px'}>
                            {t('paymentsHistoryTable.referenceMonth')}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography color={"primary"} fontWeight={700} fontSize={'14px'}>
                            {t('paymentsHistoryTable.paymentDate')}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography color={"primary"} fontWeight={700} fontSize={'14px'}>
                            {t('paymentsHistoryTable.reason')}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography color={"primary"} fontWeight={700} fontSize={'14px'}>
                            {t('paymentsHistoryTable.status')}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((item, index: number) => (
                        <TableRow
                            key={"sub" + index}
                        >
                            <TableCell>
                                <TextField
                                    style={{width: "50%"}}
                                    fullWidth
                                    name="typhology"
                                    value={item.typology ?? ''}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    style={{width: "50%"}}
                                    fullWidth
                                    name="referenceMonth"
                                    value={dayjs(item.referenceMonth).format("L") ?? ''}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                        style={{width: "50%"}}
                                        fullWidth
                                        name="paymentDate"
                                        value={dayjs(item.paymentDate).format("L") ?? ''}
                                    />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    style={{width: "50%"}}
                                    fullWidth
                                    name="reason"
                                    value={item.reason ?? ''}
                                />
                            </TableCell>
                            <TableCell>
                                <Chip label={getStatusLabelContract(item.status.toUpperCase())} sx={{backgroundColor: getStatusColorContract(item.status.toUpperCase())}}/>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </> 
}



export default PaymentsHistoryTable